import { bootstrapApplication } from '@angular/platform-browser';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { resumeNativeAuthFromDeepLink } from './app/core/auth/native-auth.util'; //ios
import { hydrateNativeKeycloakTokens } from './app/core/auth/native-keycloak-token.store';
import { fetchPublicAppConfig } from './app-config.bootstrap';
import { deferGoogleTagManager, injectGoogleTagManager } from './app/shared/utils/gtm.util';
import { isEraspaditaPlayPath } from './app/shared/services/eraspadita-play-mode.service';
import { applyWindowEnv } from './app/shared/utils/environment.util';
import { environment } from './environments/environment';
import { returnToAppFromFailedDeposit } from './app/core/auth/deposit-browser-close.util';
import {
  isLoadingDepositPath,
  lockDepositBrowserUi,
} from './app/modules/account/components/deposit/loading-deposit/loading-deposit-lock';

export type { AppConfig } from './app-config.model';

async function bootstrap() {
  if (isLoadingDepositPath()) {
    lockDepositBrowserUi();
  }

  applyWindowEnv();

  const cmsApiUrl = environment.endpointBasePaths.cmsApiUrl;
  const platform = Capacitor.getPlatform();
  const envName = environment.environmentName;

  let config;
  try {
    config = await fetchPublicAppConfig(cmsApiUrl, envName, platform);
  } catch (err) {
    console.error('[Bootstrap] Failed to load app config from CMS API:', err);
    if (isLoadingDepositPath()) {
      returnToAppFromFailedDeposit();
      return;
    }
    document.body.innerHTML = `
      <div style="
        display:flex;flex-direction:column;align-items:center;justify-content:center;
        height:100vh;font-family:sans-serif;color:#333;padding:24px;text-align:center;
      ">
        <p style="font-size:1.1rem;margin-bottom:8px;">No se pudo cargar la configuración de la aplicación.</p>
        <p style="font-size:0.9rem;color:#888;margin-bottom:24px;">Verifique su conexión e intente nuevamente.</p>
        <button onclick="location.reload()" style="
          padding:10px 24px;border:none;border-radius:6px;
          background:#005f9e;color:#fff;font-size:1rem;cursor:pointer;
        ">Reintentar</button>
      </div>`;
    return;
  }

  if (config.GOOGLE_TAG_MANAGER_ID) {
    if (isEraspaditaPlayPath(globalThis.location.pathname)) {
      deferGoogleTagManager(config.GOOGLE_TAG_MANAGER_ID);
    } else {
      injectGoogleTagManager(config.GOOGLE_TAG_MANAGER_ID);
    }
  }

  if (Capacitor.isNativePlatform()) {
    const launchUrl = await App.getLaunchUrl();
    const translatedAuthCallback = await resumeNativeAuthFromDeepLink(launchUrl?.url ?? '');

    if (translatedAuthCallback) {
      globalThis.history.replaceState({}, '', translatedAuthCallback);
    }

    await hydrateNativeKeycloakTokens();
  }

  await bootstrapApplication(AppComponent, appConfig(config));
}

bootstrap().catch((err) => console.error(err));
